import { Routes, Route } from 'react-router-dom';
import BookingRequest from './BookingRequest';

const Bookings = props => (
    <Routes>
        <Route path="*" element={<BookingRequest />} />
    </Routes>
)

export default Bookings;